import { Navigate, Outlet, useMatch } from 'react-router-dom';

export function OrganizationSettings() {
  const match = useMatch('/settings/organization');

  if (match) {
    // Redirect to default sub page
    return <Navigate to="/settings/organization/details" replace={true} />;
  }

  return <Outlet />;
}
